import { negate, isNil } from 'lodash';

export const isDefined = negate(isNil);
